"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Link;

var _react = _interopRequireDefault(require("react"));

var _useClassBuilder = _interopRequireDefault(require("../../hooks/useClassBuilder"));

var _useStyleBuilder = _interopRequireDefault(require("../../hooks/useStyleBuilder"));

var _text = _interopRequireDefault(require("../text"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*---------------------------------------------*/
var BASE_CLASS = "lth-c-link";
/*---------------------------------------------*/

function Link(props) {
  var customClasses = ["lth-body-regular"];
  props.inline && customClasses.push(BASE_CLASS + "--inline");
  props.monochrome && customClasses.push(BASE_CLASS + "--monochrome");
  var classes = (0, _useClassBuilder.default)(props, BASE_CLASS, customClasses);
  var style = (0, _useStyleBuilder.default)(props);
  var tagProps = {
    className: classes,
    style: style,
    href: props.href,
    tabIndex: 0,
    target: props.target
  };
  return /*#__PURE__*/_react.default.createElement("a", tagProps, /*#__PURE__*/_react.default.createElement(_text.default, {
    size: props.size
  }, props.children));
}
/*---------------------------------------------*/


Link.METADATA = {
  name: "Link",
  props: [{
    name: "href",
    type: "string",
    default: "#"
  }, {
    name: "target",
    type: "string",
    options: [{
      value: "_self",
      label: "Current tab"
    }, {
      value: "_blank",
      label: "New tab"
    }, {
      value: "_parent",
      label: "Parent window"
    }, {
      value: "_top",
      label: "Top window"
    }]
  }, {
    name: "size",
    type: "string",
    default: "medium",
    options: [{
      value: "medium",
      label: "Medium"
    }, {
      value: "small",
      label: "Small"
    }]
  }, {
    name: "color",
    type: "string"
  }, {
    name: "inline",
    type: "boolean"
  }, {
    name: "monochrome",
    type: "boolean"
  }, {
    name: "disabled",
    type: "boolean",
    default: false
  }, {
    name: "forcehover",
    type: "boolean",
    default: false
  }, {
    name: "forcefocus",
    type: "boolean",
    default: false
  }],
  content: {
    default: "Test link"
  }
};